var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 963,
    height: 963,
    viewBox: "0 0 963 963",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M481.33 962.93C747.161 962.93 962.66 747.431 962.66 481.6C962.66 215.769 747.161 0.27002 481.33 0.27002C215.499 0.27002 0 215.769 0 481.6C0 747.431 215.499 962.93 481.33 962.93Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M184.83 202.731L414.9 510.351L183.38 760.461H235.49L438.19 541.481L601.96 760.461H779.28L536.26 435.541L751.76 202.731H699.65L512.98 404.401L362.15 202.731H184.83ZM261.46 241.111H342.92L702.64 722.081H621.18L261.46 241.111Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.81d85224954d1612706d808ef1a2bf63.svg";
export { ForwardRef as ReactComponent };